import { Component, OnInit, Inject } from '@angular/core';
import {MD_DIALOG_DATA} from '@angular/material';
import {MdDialog, MdDialogRef} from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {
	userForm : FormGroup;
  currentUserId;
  dbUser;
  currentUser;
  db;

  constructor(fb: FormBuilder, angularFireDatabase: AngularFireDatabase, public afAuth: AngularFireAuth) {
    this.db = angularFireDatabase;
    this.userForm = fb.group({
      'displayName': [null, Validators.compose([Validators.required, Validators.minLength(3)])],
      'gamerTag': [null, Validators.compose([Validators.required, Validators.minLength(3), this.NoWhitespaceValidator])],
      'fullName': [null, Validators.compose([Validators.required, Validators.minLength(3)])],
      'address': [null, Validators.compose([Validators.required, Validators.minLength(10)])],
      'organizationNumber': [null, Validators.compose([Validators.required, Validators.minLength(3)])],
      'contactPerson': [null, Validators.compose([Validators.required, Validators.minLength(3)])],
      'contactDetails': [null, Validators.compose([Validators.required, Validators.minLength(3)])]
      });
  }

  ngOnInit() {
  	console.log('My profile');
      this.afAuth.authState.subscribe(res => {
        if (res) {
          this.currentUserId = res.uid;
          this.dbUser = this.db.object('/staging/users/' + res.uid);
          this.dbUser.subscribe(user => {
            this.currentUser=user;
            this.userForm.setValue({
                'displayName': this.currentUser.displayName,
                'gamerTag': this.currentUser.gamerTag,
                'fullName': this.currentUser.fullName,
                'address': this.currentUser.address,
                'organizationNumber': this.currentUser.organizationNumber,
                'contactPerson': this.currentUser.contactPerson,
                'contactDetails': this.currentUser.contactDetails
              }) 
            });
        }
        else {
          console.log('!!!user not logged in!!!!');
        }
    });
  }

  saveData() {
    console.log('Saving edited data', this.userForm.value);
    this.currentUser.displayName = this.userForm.value.displayName;
    this.currentUser.gamerTag = this.userForm.value.gamerTag;
    this.currentUser.fullName = this.userForm.value.fullName;
    this.currentUser.address = this.userForm.value.address;
    this.currentUser.organizationNumber = this.userForm.value.organizationNumber;
    this.currentUser.contactPerson = this.userForm.value.contactPerson;
    this.currentUser.contactDetails = this.userForm.value.contactDetails;

    this.dbUser.update(this.currentUser)
      .then( (raspuns) => {
         alert('User data saved');
         console.log('raspuns', raspuns) 
       } )
       .catch( (err) => {
         alert('Unable to save user data');
         console.log('err', err)
       } );
	}

  public NoWhitespaceValidator(control: FormControl) {
    if (/\s/.test(control.value)) {
        // It has any kind of whitespace
        return { 'whitespace': true };
    }
    else{
      return null;
    }
  }

}



// WEBPACK FOOTER //
// d:/xampp/htdocs/zenith-admin/src/app/my-profile/my-profile.component.ts